import { FormInput, FormSelect, ToggleButton } from '@common/components/forms';
import { BusinessLineSalesItemOptionModel } from '@common/models';
import { observer } from 'mobx-react';
import React, { useCallback } from 'react';
import { useFormContext } from 'react-hook-form';

export interface IProactivePrescriptionRuleSalesItemRowProps {
  salesItemName: string;
  salesItemOptions: BusinessLineSalesItemOptionModel[];
  index: number;
  listName: string;
  isHospital?: boolean;
  isDisabled?: boolean;
}

export const ProactivePrescriptionRuleSalesItemRow = observer(
  ({
    salesItemName,
    salesItemOptions,
    index,
    listName,
    isDisabled = false,
    isHospital = false,
  }: IProactivePrescriptionRuleSalesItemRowProps) => {
    const { control, register, setValue, watch } = useFormContext();
    const toggleValue = watch(`${listName}.${index}.isSelected`) ?? false;
    const selectedSalesItemOption = watch(
      `${listName}.${index}.salesItemOptionId`,
    );
    const handleToggleChange = useCallback(() => {
      setValue(`${listName}.${index}.isSelected`, !toggleValue, {
        shouldDirty: true,
      });
      if (!toggleValue === false) {
        setValue(`${listName}.${index}.salesItemOptionId`, undefined);
      }
    }, [index, listName, setValue, toggleValue]);

    return (
      <tr>
        <td>{salesItemName}</td>
        <td>
          <FormSelect
            fieldName={`${listName}.${index}.salesItemOptionId`}
            control={control}
            options={salesItemOptions}
            label=""
            mapOptionToValue={(r) => r?.salesItemOptionId}
            mapValueToOption={(salesItemOptionId) =>
              _.find(salesItemOptions, { salesItemOptionId })
            }
            getOptionLabel={(r) => r.name}
            getOptionValue={(r) => r.salesItemOptionId.toString()}
            isRequired={true}
            isDisabled={!toggleValue || isDisabled}
            validateRules={{
              validate: () => {
                if (
                  !(toggleValue === true && _.isNil(selectedSalesItemOption))
                ) {
                  return true;
                }
                return 'Required';
              },
            }}
          />
        </td>
        {isHospital && (
          <td>
            <div className="d-flex justify-content-center">
              <FormInput
                control={control}
                type="checkbox"
                fieldName={`${listName}.${index}.isPreferred`}
                label=""
                controlId="Test"
                className="big-checkbox"
                disabled
              />
            </div>
          </td>
        )}
        <td className="d-flex justify-content-end">
          <ToggleButton
            {...register(`${listName}.${index}.isSelected`)}
            checked={toggleValue}
            onChange={handleToggleChange}
            disabled={isDisabled}
          />
        </td>
      </tr>
    );
  },
);
